<template>
  <div class="preview-wrap">
    <el-button
      :class="buttonClass"
      v-bind="$attrs"
      :type="buttonType"
      :disabled="!url"
      @click="handleVideoPlay"
    >
      {{ buttonText }}
    </el-button>
    <el-dialog
      v-if="dialogShow"
      title="视频播放"
      ref="dialog"
      width="40%"
      :close-on-click-modal="false"
      :append-to-body="true"
      :visible.sync="dialogShow"
      :before-close="hide"
      :modal="modal"
    >
      <video-player ref="videoPlayer" :video-src="url" :visible.sync="dialogShow"></video-player>
      <span slot="footer" class="dialog-footer">
        <el-button @click="hide">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import VideoPlayer from '@/components/VideoPlayer'

export default {
  name: 'VideoPreview',
  components: {
    VideoPlayer
  },
  props: {
    buttonText: {
      type: String,
      default: '预览'
    },
    buttonType: {
      type: String,
      default: 'text'
    },
    buttonClass: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    modal: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      dialogShow: false
    }
  },
  methods: {
    handleVideoPlay() {
      if (this.url) {
        this.videoSrc = this.url
        this.dialogShow = true
      }
    },
    hide() {
      this.dialogShow = false
    },
  }
}
</script>
<style lang="scss" scoped>
.preview-wrap {
  display: inline-block;
}
</style>
